import React from "react";

const AccessReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.763"
      height="42.572"
      viewBox="0 0 44.763 42.572"
    >
      <g id="db97" transform="translate(-157.43 -168.126)">
        <path
          id="Path_1823"
          data-name="Path 1823"
          d="M524.742,372.345c-1.464-.317-3.078-2.154-3.572-2.835a.958.958,0,0,0-.755-.382h-1.791v10.314H526.4V374.49a2.187,2.187,0,0,0-1.66-2.145Z"
          transform="translate(-324.209 -180.42)"
          fill={fill ? fill : "#43CFE5"}
        />
        <path
          id="Path_1824"
          data-name="Path 1824"
          d="M429.678,369.5c-.494.681-2.1,2.518-3.572,2.835a2.187,2.187,0,0,0-1.66,2.145v4.952h7.777V369.122h-1.79a.959.959,0,0,0-.756.382Z"
          transform="translate(-239.674 -180.415)"
          fill={fill ? fill : "#43CFE5"}
        />
        <path
          id="Path_1825"
          data-name="Path 1825"
          d="M424.45,488.635a6.06,6.06,0,0,0,2.238,4.719l5.539,4.523v-9.81H424.45Z"
          transform="translate(-239.678 -287.179)"
          fill={fill ? fill : "#43CFE5"}
        />
        <path
          id="Path_1826"
          data-name="Path 1826"
          d="M518.62,497.882l5.539-4.523a6.061,6.061,0,0,0,2.238-4.719v-.569H518.62Z"
          transform="translate(-324.205 -287.184)"
          fill={fill ? fill : "#43CFE5"}
        />
        <path
          id="Path_1827"
          data-name="Path 1827"
          d="M196.849,170.924a2.8,2.8,0,0,0-2.8-2.8H160.227a2.8,2.8,0,0,0-2.8,2.8v3.758h39.42Z"
          fill={fill ? fill : "#43CFE5"}
        />
        <path
          id="Path_1828"
          data-name="Path 1828"
          d="M209.827,261.809a2.875,2.875,0,0,1,2.266-1.147h3.655v-10.3H181.2v21.542a2.806,2.806,0,0,0,2.8,2.8h20.246V267.89a4.062,4.062,0,0,1,3.115-3.963,6.35,6.35,0,0,0,2.472-2.117Zm-16.152-1.278a.912.912,0,0,1-1.315,0l-1.212-1.2v6.8a.932.932,0,0,1-1.865,0v-6.8l-1.2,1.2a.93.93,0,0,1-1.315-1.315l2.8-2.8a.915.915,0,0,1,1.315,0l2.8,2.8a.928.928,0,0,1,0,1.315Zm8.393,3.45-2.8,2.8a.818.818,0,0,1-.3.205,1.011,1.011,0,0,1-.364.074.933.933,0,0,1-.354-.074.818.818,0,0,1-.3-.205l-2.8-2.8a.93.93,0,0,1,1.315-1.315l1.2,1.2v-6.789a.932.932,0,0,1,1.865,0v6.789l1.212-1.2a.93.93,0,1,1,1.315,1.315Z"
          transform="translate(-21.334 -73.82)"
          fill={fill ? fill : "#43CFE5"}
        />
      </g>
    </svg>
  );
};

export default AccessReportIcon;
